<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
    <h4 class="modal-title" [innerHtml]="title"></h4>
</div>
<div class="modal-body">
    <!-- <div class=col-12> -->
        <div class="row">
            <div class="col-8">
                <h5>Print Complete Roster</h5>
                <p>Include all users assigned to this item.</p>
            </div>
            <div class="col-4 text-center">
                <button type="button" class="btn btn-primary yes-button" (click)="submit('full')">Print Complete</button>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-8">
                <h5>Print Filtered Roster</h5>
                <p>Only include users based on search filters.</p>
            </div>
            <div class="col-4 text-center">
                <button type="button" class="btn btn-primary" (click)="submit('filtered')">Print Filtered</button>
            </div>
        </div>
    <!-- </div> -->
    <div class="modal-footer" stlye="text-align: center; justify-content: center;">
        <button type="button" class="btn btn-info no-button" (click)="activeModal.dismiss('cancel')">Cancel</button>
    </div>
</div>
</div>